import { ScriptItemData, ScriptItemInput } from "@/app/types/messages-content/ScriptData";
import { UString } from "@/app/utils/UString";

export function matchesFilter(item: ScriptItemData, filter: string): boolean {
  const needle = normalize(filter);
  if (!needle) {
    return true;
  }

  return normalize(`${item.label} ${item.response ?? ""}`).includes(needle);
}

function normalize(text: string): string {
  return UString.removeAccents(text).toLowerCase().trim();
}

export function toRows(items: ScriptItemData[]): ScriptItemInput[] {
  return items.map((item) => ({ id: item.id > 0 ? item.id : null, label: item.label }));
}
